<template>
  <v-container fluid class="admin-booking">
    <v-row class="flex-grow-0">
      <v-col class="text-right">
        <v-btn color="primary"
               @click="addBooking">
          {{ $t('admin_acc_booking.add') }}
        </v-btn>
      </v-col>
    </v-row>
    <AdminRecurrentBookingList full-height
                               :refresh-trigger.sync="bookingRefreshTrigger"></AdminRecurrentBookingList>
  </v-container>
</template>
<script>
import {ref} from "@vue/composition-api";
import AddBookingModal from "@/components/acc_booking/booking/AddBookingModal";
import ExportBookingModal from "@/components/acc_booking/booking/ExportBookingModal";
import AdminRecurrentBookingList from "@/components/acc_booking/booking/AdminRecurrentBookingList.vue";

export default {
  name: 'RecurrentBooking',
  components: {AdminRecurrentBookingList},
  setup(props, {root}) {
    const bookingRefreshTrigger = ref(false);
    const refreshBooking = function () {
      bookingRefreshTrigger.value = !bookingRefreshTrigger.value;
    };

    const addBooking = async function () {
      const needRefresh = await root.$dialog.showAndWait(AddBookingModal, {
        showClose: false,
        persistent: true,
        width: '80vw',
      });

      if (needRefresh) {
        refreshBooking();
      }
    }
    const exportBookings = async function () {
      await root.$dialog.showAndWait(ExportBookingModal, {
        showClose: false,
        persistent: true,
      })
    }

    return {
      bookingRefreshTrigger,
      refreshBooking,

      addBooking,
      exportBookings,
    }
  }
}
</script>

<style lang="less">
.admin-booking {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>

